import { ButtonColor, ButtonVariant } from "enums/Button";
import styled from "styled-components";
import Button, { ButtonProps } from "../Button/Button";

const PAYMENT_BUTTON_VERTICAL_PADDING = "24px";
const PAYMENT_FOOTER_CONTENT_GAP = "40px";
const ARTICLE_LINK_ROW_GAP = "8px 16px";

const getDefaultButtonProps = (props: ButtonProps) => ({
  color: props.color ?? ButtonColor.Secondary,
  variant: props.variant ?? ButtonVariant.Filled,
});

export const StyledPaymentButton = styled(Button).attrs<ButtonProps>(
  getDefaultButtonProps,
)`
  font-weight: bold;
  padding: 9px 30px;
`;

export const PaymentButtonSlot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  padding: ${PAYMENT_BUTTON_VERTICAL_PADDING} 0;
`;

export const PaymentFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${PAYMENT_FOOTER_CONTENT_GAP};
`;

export const PaymentPolicyLinksContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const PaymentPolicyLinksList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${ARTICLE_LINK_ROW_GAP};
`;

export const PaymentPolicyLinkButton = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.primary};
  font-size: 13px;
  line-height: 1.4;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;

  &:hover {
    color: ${({ theme }) => theme.primaryDark};
  }
`;
